// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaPinterest_root__54CTJ"};